import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Menu.html?raw';
import on from 'dojo/on';
import FloatingContainer from '../Floating/FloatingContainer';
import { TranslationHelpers } from "../../../more/Helpers";
import { MenuEntry, MenuGroup } from "./FloatingTypes";
import Tooltip from './Tooltip';

class FloatingMenu extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private name: string = "home";

    entryContainer: HTMLElement;
    heading: HTMLElement;
    topBar: HTMLElement;

    private floatingContainer: MdsLax<InstanceType<typeof FloatingContainer>>;
    private groups: Array<MenuGroup>;

    path: string = "<i class='fas fa-home'></i>";

    previousMenu: FloatingMenu;
    nextMenus: Array<FloatingMenu> = [];

    private cyentrycounter: number = 0; //damit wir zumindest eine uid erfindne koennen...

    /**
     * Fragt ab, ob eine Gruppe mit dem internen Namen name existiert. Das erleichtert die Entscheidung, ob eine Gruppe ggf. noch via addGroup mit Label und Icon aktualisiert werden muss.
     */
    hasGroup(name: string): boolean {
        return this.getGroupByName(name) != null;
    }
    /**
     * Neue Gruppierung im Menü einfügen, um die Einträge zu organisieren. Falls die Gruppe existiert, werden label und icon ggf. aktualisiert.
     * @param name Interner Name. Eine Gruppe ohne Namen ist in jedem Menü vorhanden. Falls die Gruppe existiert, werden label und icon ggf. aktualisiert.
     * @param label Falls nicht leer: Überschrift wird in der Gruppe erzeugt oder aktualisiert.
     * @param iconClass Falls nicht leer: Der Gruppenüberschrift wird ein Icon vorangestellt oder aktualisiert.
     */
    addGroup(name: string, label?: string, iconClass?: string, bIsGroupNextLevel?: boolean, parentGroupName?: string) {
        let group = this.getGroupByName(name);
        let groupMenu = this.findGroupMenu(name);


        if (!group && !groupMenu) this.createGroup(name, label, iconClass, bIsGroupNextLevel, parentGroupName);

        else if (group) {
            if (typeof (label) != "undefined") {
                // Achtung: im Label ist ggf. ein Icon drin
                // das Label erst mal klonen, das Icon rausholen, das alte danach löschen
                if (TranslationHelpers.canTranslate(label)) label = TranslationHelpers.translate(label);

                let clone = lang.clone(group.labelNode);
                this.UiModder.domConstruct.place(clone, group.containerNode, "first");

                clone.innerHTML = ""; // würde das Icon löschen!
                if (label) clone.innerHTML = label;

                if (group.iconNode) this.UiModder.domConstruct.place(group.iconNode, clone, "first");
                this.UiModder.domConstruct.destroy(group.labelNode);
                group.labelNode = clone;



            }

            if (typeof (iconClass) != "undefined" ) {
                let newIcon = null;
                if (iconClass) newIcon = this.createFontawesomeIcon(iconClass + " groupIcon", "");

                if (group.iconNode) this.UiModder.domConstruct.destroy(group.iconNode);

                group.iconNode = newIcon;

                if (newIcon) {
                    if (group.iconNode) this.UiModder.domConstruct.place(newIcon, group.labelNode, "first");
                }
            }

            this.hideNode(group.labelNode, !label && !group.iconNode);
        }
    }

    getEntryCount(countInactive: boolean = true): number {
        let count = 0;
        for (let group of this.groups) {
            for (let entry of group.entries) {
                if (entry.enabled == true || countInactive == true) {
                    count++;
                }
            }
        }

        return count;
    }

    //ES TUT MIR LEID ROMAN. ICH BRAUCHE DEINE HILFE UM EINE BESSERE LÖSUNG ZU FINDEN T_T
    sortEntriesByOrder(): void {
        for (let group of this.groups) {
            let groupEntries = Array.prototype.slice.call(group.containerNode.children, 0);
            groupEntries.sort((a, b) => {
                return parseInt(a.getAttribute("order")) - parseInt(b.getAttribute("order"));
            });
            this.UiModder.domConstruct.empty(group.containerNode);
            for (let entry of groupEntries) {
                this.UiModder.domConstruct.place(entry, group.containerNode);
            }

        }
    }

    private setName(name: string) {
        this.name = name;
    }

    private getGroupEntryByName(groupEntryName: string): MenuEntry {
        var foundEntry = null;
        for (var group of this.groups) {
            for (let entry of group.entries) {
                if (entry.name && groupEntryName && entry.name === groupEntryName) {
                    foundEntry = entry;
                }
            }
        }
        return foundEntry;
    }

    private getGroupByName(name: string): MenuGroup {
        for (let group of this.groups) {
            if (group.name == name) {
                return group;
            }
        }

        return null;
    }

    private findGroupMenu(groupName: string): FloatingMenu {
        if (!groupName) return null;
        if (this.name === groupName) {
            return this;
        } else if (!this.nextMenus) {
            return null;
        } else {
            let foundMenu: FloatingMenu;
            for (let menu of this.nextMenus) {
                foundMenu = menu.findGroupMenu(groupName);
                if (foundMenu) break;
            }
            return foundMenu;
        }
    }



    private createGroup(name: string, label?: string, iconClass?: string, bIsGroupNextLevel?: boolean, parentGroupName?: string): MenuGroup {

        if (bIsGroupNextLevel) {
            //If groupEntry already exsists exit function
            if (this.getGroupEntryByName(name)) return;

            if (!parentGroupName) parentGroupName = "home";

            let parentMenu = this.findGroupMenu(parentGroupName);
            if (!parentMenu) {
                alert("Error: parentmenu not found");
                return;
            }

            let newGroupMenu = new FloatingMenu();
            newGroupMenu.previousMenu = parentMenu;
            parentMenu.nextMenus.push(newGroupMenu);
            newGroupMenu.setName(name);

            newGroupMenu.path = this.path + " - " + label;

            var backGroup = newGroupMenu.createGroup("backbutton");
            newGroupMenu.addEntry({
                callback: lang.hitch(newGroupMenu, newGroupMenu.openPreviousLevel),
                label: this.translate("FloatingMenu_Label_Back"),
                icon: "fas fa-chevron-left",
                hasPreviousLevel: true,
                groupname: "backbutton"
            });

            newGroupMenu.setPath(backGroup, parentMenu.path);

            let newGroupButton = parentMenu.addEntry({
                label: label,
                icon: iconClass,
                callback: lang.hitch(parentMenu, parentMenu.openNextLevel, newGroupMenu),
                hasNextLevel: true,
                name: name,
                groupname: parentGroupName
            });
            this.hideNode(newGroupButton, true);

        } else {
            let containerNode = this.UiModder.domConstruct.create("div", {
                className: "groupContainer",
                "data-groupname": name,
            }, this.entryContainer, name === "backbutton" ? "first" : name === "_default" ? "" : "last");

            let labelNode = this.UiModder.domConstruct.create("div", {
                className: "heading",
                innerHTML: label ? label : ""
            }, containerNode);

            this.hideNode(containerNode, true);
            this.hideNode(labelNode, !label);

            let group: MenuGroup = {
                name: name,
                heading: label,
                labelNode: labelNode,
                containerNode: containerNode,
                iconNode: null,
                entries: []
            };

            if (label) {
                let node = group.labelNode;
                if (iconClass) {
                    let icon = this.createFontawesomeIcon(iconClass + " groupIcon", "");
                    this.UiModder.domConstruct.place(icon, node, "first");

                    group.iconNode = icon;
                }
            }


            this.groups.push(group);

            return group;
        }
    }

    private setPath(group: MenuGroup, path: string): void {
        if (group.pathNode) {
            group.pathNode.innerHTML = `${this.translate("General_Label_To")} ${path}`;
        } else {
            let pathNode = this.UiModder.domConstruct.create("div", {
                className: "path",
                innerHTML: `${this.translate("General_Label_To")}: ${path}`
            }, group.containerNode, "last");
        }
    }

    addSeparator(heading?: string) {
        // die aktuelle Gruppe "abschließen", indem sie umgetauft wird:
        let currentGroup = this.getGroupByName( heading ? heading : "_default");
        if (currentGroup) {
            currentGroup.name = (Math.random() * 100000).toString();

            // dadurch wird die Gruppe bei weiteren Einträgen nicht mehr gefunden und ggf dieselbe Überschrift neu erzeugt
        }

        //

        let group = this.createGroup(heading ? heading : "_default", heading);
        this.UiModder.domConstruct.place(group.containerNode, this.entryContainer, "last"); // auch wenns _default ist: in diesem Fall nach unten platzieren!
    }

    clearEntries() {
        this.UiModder.domConstruct.empty(this.entryContainer);
        this.groups = [];
        this.nextMenus = [];
        this.previousMenu = null;
    }
    /**
     * Fügt einen Menüeintrag ein.
     * Hinweis: Labels werden mit canTranslate übersetzt, falls möglich.
     * @param entry Konfiguration des Eintrags. Als Icon kann auch ein HTML-Element eingefügt werden.
     * @param groupName
     */
    addEntry(entry: MenuEntry, groupName?: string): HTMLElement {

        let parentGroupMenu = this.findGroupMenu(entry.groupname);
        if (parentGroupMenu && this.name !== entry.groupname) {
            parentGroupMenu.addEntry(entry, groupName);


        } else {
            let targetGroupName = groupName ? groupName : entry.groupname ? entry.groupname : entry.heading ? entry.heading : "_default";
            entry.groupname = targetGroupName
            let group = this.getGroupByName(entry.groupname);
            if (!group) group = this.createGroup(entry.groupname, entry.heading);

            entry.order = entry.order ? entry.order : 900;

            let entryNode = this.UiModder.domConstruct.create("button", {
                className: "menuEntry",
                order: entry.order
            }, group.containerNode);

            this.cyentrycounter++;
            entryNode.setAttribute("data-cy", "floatmenu:" + (entry.name ?? entry.label));

            entry.hasNextLevel = entry.hasNextLevel ? entry.hasNextLevel : false;
            entry.entryNode = entryNode;


            //Changed to assign node to every menu Entry
            //entry.entryNode = entryNode;


            //let headingChanged: boolean = false;
            //if (entry.heading != this._previousHeadingLabel) {
            //    this.addHeading(entry.heading);
            //    entry.heading ? headingChanged = false : headingChanged = true;
            //}

            //this.UiModder.domClass.toggle(node, "headingChanged", headingChanged);

            let translatedLabel = entry.label;
            if (this.canTranslate(entry.label, false)) translatedLabel = this.translate(entry.label);

            let label = this.UiModder.domConstruct.create("span", {
                innerHTML: translatedLabel
            }, entryNode);

            if (entry.icon) {
                if (typeof (entry.icon) == "string") {
                    let icon = this.createFontawesomeIcon(entry.icon);
                    this.UiModder.domConstruct.place(icon, entryNode, "first");
                    this.UiModder.domClass.add(icon, "icon");
                } else if (entry.icon instanceof HTMLElement) {
                    let icon = entry.icon;
                    this.UiModder.domConstruct.place(icon, entryNode, "first");
                    this.UiModder.domClass.add(icon, "icon");
                }
                this.UiModder.domClass.add(this.entryContainer, "hasIcons"); // mit :has-Selektor gehts einfach ned. was weiß ich warum!!
            } else {
                this.UiModder.domConstruct.create("div", { "className": "icon" }, entryNode, "first"); // DUMMY
            }
            if (entry.hasNextLevel) {
                var arrowIcon = this.createFontawesomeIcon("fas fa-chevron-right");
                this.UiModder.domConstruct.place(arrowIcon, entryNode, "last");
                this.UiModder.domClass.add(arrowIcon, "icon-right");
            }

            if (entry.enabled === false || typeof (entry.callback) != "function") {
                this.UiModder.domClass.add(entryNode, "w3-disabled disabled");
            } else {
                this.UiModder.domClass.toggle(entryNode, "hoverDark", entry.enabled != "selected");

                if (typeof (entry.callback) == "function") {
                    on(entryNode, "click", lang.hitch(this, this._onClick_Entry, entry.callback, entry));
                }
            }

            this.UiModder.domClass.toggle(entryNode, "selected", entry.enabled == "selected");

            if (entry.coloration) {
                if (typeof (entry.coloration) == "string") {
                    let color = this.getHexColorFromString(entry.coloration);
                    entryNode.style.setProperty("--coloration", color);
                    this.UiModder.domClass.add(entryNode, "colored");
                } else if (entry.coloration.BackColor) {
                    entryNode.style.setProperty("--coloration", entry.coloration.BackColor.Hex);
                    this.UiModder.domClass.add(entryNode, "colored");
                }
            }

            if (entry.tooltipConfig) {
                //this.UiModder.domAttr.set(entryNode, "title", entry.tooltipConfig.content);
                let tooltip = new Tooltip();
                tooltip.setup({
                    targetnode: entryNode,
                    ...entry.tooltipConfig
                });
            }
            
            group.entries.push(entry);

            if (!entry.hasNextLevel) {
                this.hideNode(group.containerNode, false);

                this.unhideGroupsRecursive(this, entry);
            }

            //this.unhideGroupsRecursive(this, entry);

            //let groupEntry = this.previousMenu ? this.previousMenu.getGroupEntryByName(entry.groupname) : null;
            //if (groupEntry) {
            //    this.hideNode(groupEntry.entryNode, false);
            //    var entryGroup = this.previousMenu ? this.previousMenu.getGroupByName(groupEntry.groupname) : null;
            //    if (entryGroup) this.hideNode(entryGroup.containerNode, false);
            //}

            return entryNode;
        }

    }

    unhideGroupsRecursive(menu: FloatingMenu, entry: MenuEntry) {
        let groupEntry = menu.previousMenu ? menu.previousMenu.getGroupEntryByName(entry.groupname) : null;
        if (groupEntry) {
            this.hideNode(groupEntry.entryNode, false);
            var entryGroup = menu.previousMenu ? menu.previousMenu.getGroupByName(groupEntry.groupname) : null;
            if (entryGroup) this.hideNode(entryGroup.containerNode, false);
            this.unhideGroupsRecursive(menu.previousMenu, groupEntry);
        }
    }

    private _onClick_Entry(callback: Function, entry: MenuEntry, evt: MouseEvent) {
        evt.stopPropagation();
        evt.preventDefault();
        callback(evt, this, entry);
        if (!entry.hasNextLevel && !entry.hasPreviousLevel) this.close();

    }

    openNextLevel(menu: FloatingMenu): void {
        menu.floatingContainer = this.floatingContainer;
        this.floatingContainer.setNewContent(menu.domNode);
    }


    private openPreviousLevel(): void {
        if (this.previousMenu) {
            this.floatingContainer.setNewContent(this.previousMenu.domNode);
        }
    }

    private _onClick_Heading(evt: MouseEvent) {
        evt.stopPropagation(); // nix tun
    }

    private _onClick_Close(evt) {
        this.close();
    }
    /**
 * Unbedingt das Klickevent mitgeben, darauf positioniert sich das Menü anschließend.
 * @param evt Klickevent
 */
    open(evt: MouseEvent | Event, entries?: Array<MenuEntry>, heading?: string, fixToElement?: HTMLElement) {
        this.floatingContainer = new FloatingContainer();
        this.floatingContainer.open(evt, this.domNode, false, false, fixToElement);
        on(this.floatingContainer, "close", lang.hitch(this, this._onCloseFloatingContainer));

        this._state = "open";

        if (entries) {
            this.UiModder.domConstruct.empty(this.entryContainer);

            for (let entry of entries) {
                this.addEntry(entry);
            }
        }

        if (heading) {
            if (this.canTranslate(heading)) heading = this.translate(heading);
            this.UiModder.domAttr.set(this.heading, "innerHTML", heading);
            this.UiModder.domClass.remove(this.topBar, "w3-hide");
        }

        this.sortEntriesByOrder();
    }
    close() {
        if (this._destroyed) return;

        this._onCloseFloatingContainer();
        this.floatingContainer.close();
    }

    private _state: "open" | "closed" = "closed";

    private _closeNestedFloatingContainers(): void {
        this.closePreviousMenuContainer(this.previousMenu);
        this.closeNextMenuContainers(this.nextMenus);
    }

    private closePreviousMenuContainer(menu: FloatingMenu) {
        if (menu) {
            menu.closePreviousMenuContainer(menu.previousMenu);
            menu.destroy();
        }
    }

    private closeNextMenuContainers(menus: Array<FloatingMenu>) {
        for (var menu of menus) {
            menu.closeNextMenuContainers(menu.nextMenus);
            menu.destroy();
        }
    }

    isOpen(): boolean {
        return this._state == "open";
    }

    private _onCloseFloatingContainer() {
        this.closePreviousMenuContainer(this.previousMenu);
        this.closeNextMenuContainers(this.nextMenus);

        this.destroy();
        if (this.domNode) this.domNode.remove();
        this._state = "closed";
        this.emit("close");
        
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

        this.groups = [];
    //    this.createGroup("_default", ""); // leere Gruppe immer erstellen... oder?
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(FloatingMenu);
